/* Dunkel Braun – landing page behaviour (carousels, add to cart, favourites, store locator) */
(function () {
  if (window.__dbHome) return;
  window.__dbHome = true;

  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var rootUrl = function () { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; };

  /* ---------- carousels: [data-dhc] ---------- */
  function initContinuousCarousel(box) {
    var track = box.querySelector('[data-dhc-track]');
    if (!track || box._dhc) return;
    box._dhc = true;

    var originals = Array.prototype.slice.call(track.children);
    if (!originals.length) return;

    var reducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    );

    // Leave the original cards manually scrollable for reduced motion.
    if (reducedMotion.matches) return;

    var speed = 40; // Pixels per second. Lower = slower.
    var hovered = false;
    var focused = false;
    var cycleWidth = 0;
    var position = track.scrollLeft;
    var previousTime = null;
    var frameId;

    track.style.scrollSnapType = 'none';
    track.style.scrollBehavior = 'auto';

    originals.forEach(function (card) {
      card.style.flexShrink = '0';
    });

    function cloneCard(card) {
      var clone = card.cloneNode(true);

      clone.setAttribute('data-loop-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('inert', '');
      clone.removeAttribute('id');
      clone.removeAttribute('data-shopify-editor-block');

      clone.querySelectorAll('[id]').forEach(function (element) {
        element.removeAttribute('id');
      });

      clone.querySelectorAll('a, button, input, select, textarea, [tabindex]')
        .forEach(function (element) {
          element.setAttribute('tabindex', '-1');
        });

      return clone;
    }

    function rebuild() {
      track.querySelectorAll('[data-loop-clone]').forEach(function (clone) {
        clone.remove();
      });

      if (!track.clientWidth || !originals[0].getBoundingClientRect().width) {
        cycleWidth = 0;
        return;
      }

      // Repeat short rows until a full cycle fills the visible area.
      var cycleCards = originals.slice();
      var firstClone;

      do {
        firstClone = null;

        originals.forEach(function (card) {
          var clone = cloneCard(card);
          if (!firstClone) firstClone = clone;
          track.appendChild(clone);
          cycleCards.push(clone);
        });

        cycleWidth =
          firstClone.getBoundingClientRect().left -
          originals[0].getBoundingClientRect().left;
      } while (cycleWidth < track.clientWidth);

      // The final added set is the start of the duplicate cycle.
      var prefix = cycleCards.slice(0, cycleCards.length - originals.length);

      // Complete that duplicate cycle.
      prefix.slice(originals.length).forEach(function (card) {
        track.appendChild(cloneCard(card));
      });

      position = 0;
      track.scrollLeft = 0;
      previousTime = null;
    }

    function animate(time) {
      if (!box.isConnected) return;

      var elapsed = previousTime === null ? 0 : time - previousTime;
      previousTime = time;

      if (
        cycleWidth > 0 &&
        !hovered &&
        !focused &&
        !document.hidden &&
        !reducedMotion.matches
      ) {
        position = (position + speed * Math.min(elapsed, 50) / 1000)
          % cycleWidth;
        track.scrollLeft = position;
      }

      frameId = requestAnimationFrame(animate);
    }

    box.addEventListener('mouseenter', function () {
      hovered = true;
    });

    box.addEventListener('mouseleave', function () {
      hovered = false;
    });

    box.addEventListener('focusin', function () {
      focused = true;
    });

    box.addEventListener('focusout', function (event) {
      focused = box.contains(event.relatedTarget);
    });

    track.addEventListener('scroll', function () {
      if (hovered || focused) position = track.scrollLeft;
    }, { passive: true });

    // Step controls aren't needed for continuous movement.
    box.querySelectorAll(
      '[data-dhc-prev], [data-dhc-next], [data-dhc-dots]'
    ).forEach(function (control) {
      control.hidden = true;
    });

    rebuild();

    var observer = new ResizeObserver(function () {
      if (!box.isConnected) {
        observer.disconnect();
        cancelAnimationFrame(frameId);
        return;
      }
      rebuild();
    });

    observer.observe(track);
    frameId = requestAnimationFrame(animate);
  }

  function initCarousel(box) {
    if (box._dhc) return;
    if (box.hasAttribute('data-continuous')) {
      initContinuousCarousel(box);
      return;
    }
    box._dhc = true;
    var track = box.querySelector('[data-dhc-track]');
    if (!track) return;
    var dotsBox = box.querySelector('[data-dhc-dots]');
    var timer = null, paused = false;

    function slides() { return Array.prototype.slice.call(track.children); }
    function step() {
      var s = slides();
      if (s.length > 1) return s[1].offsetLeft - s[0].offsetLeft;
      return track.clientWidth;
    }
    function index() { var st = step(); return st ? Math.round(track.scrollLeft / st) : 0; }
    function atEnd() { return track.scrollLeft + track.clientWidth >= track.scrollWidth - 4; }
    function go(i, smooth) { track.scrollTo({ left: i * step(), behavior: smooth === false ? 'auto' : 'smooth' }); }
    function next() { if (atEnd()) go(0); else track.scrollBy({ left: step(), behavior: 'smooth' }); }
    function prev() { if (track.scrollLeft <= 2) go(slides().length - 1); else track.scrollBy({ left: -step(), behavior: 'smooth' }); }

    var dots = [];
    function buildDots() {
      if (!dotsBox) return;
      dotsBox.innerHTML = '';
      dots = slides().map(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'dhc-dot';
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        b.addEventListener('click', function () { go(i); restart(); });
        dotsBox.appendChild(b);
        return b;
      });
      markDots();
    }
    function markDots() {
      var i = atEnd() && slides().length > 1 ? slides().length - 1 : index();
      dots.forEach(function (d, n) { if (n === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
    }
    track.addEventListener('scroll', markDots, { passive: true });

    var p = box.querySelector('[data-dhc-prev]'), n = box.querySelector('[data-dhc-next]');
    if (p) p.addEventListener('click', function () { prev(); restart(); });
    if (n) n.addEventListener('click', function () { next(); restart(); });

    var ms = parseInt(box.getAttribute('data-autoplay'), 10) || 0;
    function stop() { clearInterval(timer); timer = null; }
    function start() { if (!ms || reduce || timer) return; timer = setInterval(function () { if (!paused && !document.hidden) next(); }, ms); }
    function restart() { stop(); start(); }
    box.addEventListener('mouseenter', function () { paused = true; });
    box.addEventListener('mouseleave', function () { paused = false; });
    box.addEventListener('focusin', function () { paused = true; });
    box.addEventListener('focusout', function () { paused = false; });
    box.addEventListener('touchstart', function () { paused = true; }, { passive: true });
    box.addEventListener('touchend', function () { setTimeout(function () { paused = false; }, 2500); }, { passive: true });

    buildDots();
    window.addEventListener('resize', markDots);
    start();
  }

  /* ---------- store locator: [data-dh-store] ---------- */
  function initStore(root) {
    if (root._dhs) return;
    root._dhs = true;
    var cards = root.querySelectorAll('.dh-scardb');
    var $ = function (s) { return root.querySelector(s); };
    var nameEl = $('[data-s-name]'), addrEl = $('[data-s-addr]'), hoursEl = $('[data-s-hours]');
    var imgEl = $('[data-s-img]'), dirEl = $('[data-s-dir]'), viewEl = $('[data-s-view]'), indEl = $('[data-s-ind]');

    function select(card) {
      var d = card.dataset;
      nameEl.textContent = 'Dunkel Braun : ' + d.area;
      addrEl.textContent = '';
      d.address.split('\n').forEach(function (line, i) {
        if (i) addrEl.appendChild(document.createElement('br'));
        addrEl.appendChild(document.createTextNode(line));
      });
      hoursEl.textContent = d.hours;
      if (d.image) { imgEl.src = d.image; imgEl.alt = 'Dunkel Braun ' + d.area + ' storefront'; }
      dirEl.href = 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(d.query);
      viewEl.href = 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(d.query);
      if (indEl) indEl.textContent = d.area;
      cards.forEach(function (c) { c.classList.remove('is-selected'); c.setAttribute('aria-pressed', 'false'); });
      card.classList.add('is-selected'); card.setAttribute('aria-pressed', 'true');
    }
    cards.forEach(function (c) { c.addEventListener('click', function () { select(c); }); });
    if (cards[0]) select(cards[0]);
  }

  function initAll() {
    document.querySelectorAll('[data-dhc]').forEach(initCarousel);
    document.querySelectorAll('[data-dh-store]').forEach(initStore);
    try {
      var favs = JSON.parse(localStorage.getItem('db_favs') || '[]');
      document.querySelectorAll('[data-dh-fav]').forEach(function (b) {
        b.setAttribute('aria-pressed', favs.indexOf(b.dataset.dhFav) > -1 ? 'true' : 'false');
      });
    } catch (e) {}
  }

  /* ---------- delegated clicks ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var step = t.closest && t.closest('[data-dh-step]');
    if (step) {
      var input = step.parentNode.querySelector('input[name="quantity"]');
      input.value = Math.max(1, (Number(input.value) || 1) + Number(step.dataset.dhStep));
      return;
    }
    var fav = t.closest && t.closest('[data-dh-fav]');
    if (fav) {
      var on = fav.getAttribute('aria-pressed') !== 'true';
      fav.setAttribute('aria-pressed', on ? 'true' : 'false');
      try {
        var list = JSON.parse(localStorage.getItem('db_favs') || '[]').filter(function (x) { return x !== fav.dataset.dhFav; });
        if (on) list.push(fav.dataset.dhFav);
        localStorage.setItem('db_favs', JSON.stringify(list));
      } catch (err) {}
    }
  });

  /* ---------- add to cart: forms with [data-dh-form] ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-dh-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var label = form.querySelector('[data-dh-label]') || btn;
    var original = label.textContent;
    var id = Number(form.querySelector('[name="id"]').value);
    var qtyEl = form.querySelector('[name="quantity"]');
    var qty = Math.max(1, Number(qtyEl && qtyEl.value) || 1);
    var after = form.closest('[data-after]') ? form.closest('[data-after]').dataset.after : 'cart';
    btn.setAttribute('aria-busy', 'true');
    fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function () {
      if (after === 'cart') { window.location.href = rootUrl() + 'cart'; return; }
      label.textContent = 'Added';
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      setTimeout(function () { label.textContent = original; }, 1800);
    }).catch(function () {
      label.textContent = 'Error';
      setTimeout(function () { label.textContent = original; }, 1800);
    }).then(function () { btn.removeAttribute('aria-busy'); });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
